import type { ApiError } from '~types/api';

export const getApiErrorText = (
	error: ApiError | null,
	fallback?: string,
): string | null => {
	if (error) {
		return (
			error?.response?.data?.error ??
			error?.message ??
			fallback ??
			'Something went wrong'
		);
	} else {
		return null;
	}
};
